package games.polyclub.website.frontend.store.hooks

import games.polyclub.website.frontend.store.StoreBff

fun useRefreshToken(): suspend ()-> Unit {
    val ctx = useAuth()
    suspend fun refresh() {
        val response = StoreBff.refreshAuthToken()?.getOrNull()
        ctx.setAuth(response)
    }
    return ::refresh
}
